/* src/app/account/partials/opportunity-section/opportunity-section.component.scss */
/*# sourceMappingURL=opportunity-section.component.css.map */
